/* eslint-disable default-case */
import axios from 'axios';
import moment from 'moment';
import searchFilters from '../data/search-filters';
import licenses from '../data/licenses';

export default {

  data() {
    return {
      filtersDisplay: [],
      searchFilters,
      licenses,
    };
  },

  methods: {

    filtersHandler(i, filterId, filterValue) {
      if (typeof this.filtersDisplay[i] === 'undefined') {
        this.filtersDisplay[i] = {};
      }
      switch (this.searchFilters[filterId].handler) {
        case 'plain':
          this.filtersDisplay[i][filterId] = filterValue;
          break;
        case 'type': {
          const timerType = setInterval(() => {
            if (this.$store.getters['types/getType'](filterValue)) {
              clearInterval(timerType);
              this.filtersDisplay[i][filterId] =
                (this.$store.getters['types/getType'](filterValue)).Title;
              this.$forceUpdate();
            }
          }, 100);
          break;
        }
        case 'org': {
          const timerOrg = setInterval(() => {
            if (this.$store.getters['orgs/getOrgById'](filterValue)) {
              clearInterval(timerOrg);
              this.filtersDisplay[i][filterId] =
                (this.$store.getters['orgs/getOrgById'](filterValue)).Name;
              this.$forceUpdate();
            }
          }, 100);
          break;
        }
        case 'license':
          this.filtersDisplay[i][filterId] = this.licenses[filterValue].Title;
          break;
        case 'vocabulary' : {
          const voc = this.searchFilters[filterId].voc;
          axios.post('vocabularies/values', {
            voc, q: [filterValue],
          }).then((resp) => {
            this.filtersDisplay[i][filterId] = resp.data[filterValue];
            this.$forceUpdate();
          }).catch(err => this.log('err', err));
          break;
        }
        case 'boolean':
          this.filtersDisplay[i][filterId] = filterValue ? 'да' : 'нет';
          break;
        case 'date': {
          this.filtersDisplay[i][filterId] = moment.unix(filterValue).format('DD.MM.YYYY');
          this.$forceUpdate();
          break;
        }
      }
    },

  },

};



// WEBPACK FOOTER //
// ./src/mixins/SearchFilters.js